import { render, staticRenderFns } from "./noticeList.vue?vue&type=template&id=32e061da&scoped=true&"
import script from "./noticeList.vue?vue&type=script&lang=js&"
export * from "./noticeList.vue?vue&type=script&lang=js&"
import style0 from "./noticeList.vue?vue&type=style&index=0&id=32e061da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e061da",
  null
  
)

export default component.exports